import React from 'react';
import ReactDOM from 'react-dom/client';
import './app/globals.css';
import './theme/themeFonts.css';
import ClientApp from './components/App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClientApp />
  </React.StrictMode>,
);
